<div class="">
  <h2 class="sub-header-bar">Atomic Rules</h2>
  <p-table
    [value]="atomicRules"
    selectionMode="single"
    [(selection)]="selectedAtomicRule"
    (onRowSelect)="onAtomicRuleSelect()"
    [loading]="loading"
    [scrollable]="true"
    scrollHeight="300px"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Rule</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rule>
      <tr [pSelectableRow]="rule">
        <td>
          <span>{{ atomicRuleTextStrings.get(rule.id) }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="text-align: right" class="mt-2">
    <button type="button" pButton icon="fa fa-plus" (click)="addAtomicRule()" label="Add"></button>
  </div>

  <div class="mt-3">
    <h2 class="sub-header-bar">Compound Rules</h2>
  </div>
  <p-table
    [value]="compoundRules"
    selectionMode="single"
    [(selection)]="selectedCompoundRule"
    (onRowSelect)="onCompoundRuleSelect()"
    [autoLayout]="true"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 2.5em"></th>
        <th>Rule</th>
        <th>Grade</th>
        <th>Display Order</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rule let-index="rowIndex">
      <tr [pSelectableRow]="rule">
        <td>
          <button
            class="sort-btn"
            pButton
            icon="fa fa-angle-up"
            [disabled]="index == 0 || index == compoundRules.length - 1 || saving"
            (click)="moveCompoundRuleUp(index)"
          ></button>
          <button
            class="sort-btn"
            pButton
            icon="fa fa-angle-down"
            [disabled]="index > compoundRules.length - 3 || saving"
            (click)="moveCompoundRuleDown(index)"
          ></button>
        </td>
        <td>
          <span>{{ compoundRuleTextStrings.get(rule.id) }}</span>
        </td>
        <td>
          <ng-template
            *ngTemplateOutlet="
              gradingDisplay;
              context: { $implicit: gradings.get(rule.deployPriorityGradingId) }
            "
          >
          </ng-template>
        </td>
        <td style="text-align: center">{{ rule.displayOrder }}</td>
      </tr>
    </ng-template>
  </p-table>
  <div style="text-align: right" class="mt-2">
    <button
      type="button"
      pButton
      icon="fa fa-plus"
      (click)="addCompoundRule()"
      label="Add"
    ></button>
  </div>
</div>

<p-dialog
  [header]="atomicRuleDialogHeader"
  [(visible)]="showAtomicRuleDialog"
  [modal]="true"
  [style]="{ width: '500px' }"
  (onHide)="updateAtomicRuleDto = null"
>
  <div *ngIf="updateAtomicRuleDto">
    <div class="grid">
      <div class="col-4">
        <label>Property</label>
      </div>

      <div class="col-8 px-2">
        <p-listbox
          [options]="propertyOptions"
          [(ngModel)]="updateAtomicRuleDto.property"
        ></p-listbox>
      </div>

      <div class="col-4">
        <label>Operator</label>
      </div>

      <div class="col-8 px-2">
        <p-selectButton
          [options]="operatorOptions"
          [(ngModel)]="updateAtomicRuleDto.operator"
        ></p-selectButton>
      </div>

      <div class="col-4">
        <label>Comparison Value</label>
      </div>

      <div class="col-8 px-2">
        <input pInputText type="number" [(ngModel)]="updateAtomicRuleDto.comparisonValue" />
      </div>
    </div>
  </div>
  <p-footer>
    <button
      (click)="saveAtomicRule()"
      pButton
      [label]="saving ? 'Wait..' : 'Save'"
      [disabled]="saving"
    ></button>
    <button
      *ngIf="!isNewAtomicRule"
      (click)="deleteAtomicRule()"
      pButton
      [label]="saving ? 'Wait..' : 'Delete'"
      [disabled]="saving || selectedAtomicRuleUsed"
      [title]="selectedAtomicRuleUsed ? 'Atomic rule is in use' : ''"
    ></button>
  </p-footer>
</p-dialog>

<p-dialog
  [header]="compoundRuleDialogHeader"
  [(visible)]="showCompoundRuleDialog"
  [modal]="true"
  [style]="{ width: '500px' }"
  (onHide)="updateCompoundRuleDto = null"
>
  <div *ngIf="updateCompoundRuleDto">
    <div class="grid mb-2" *ngIf="!updateCompoundRuleDto.isElseClause">
      <div class="col-4">
        <label>Primary Rule</label>
      </div>

      <div class="col-8 px-2">
        <p-dropdown
          [options]="primaryAtomicRuleOptions"
          [(ngModel)]="updateCompoundRuleDto.primaryAtomicRuleId"
        ></p-dropdown>
      </div>

      <div class="col-4">
        <label>Secondary Rule</label>
      </div>

      <div class="col-8 px-2">
        <p-dropdown
          [options]="secondaryAtomicRuleOptions"
          [(ngModel)]="updateCompoundRuleDto.secondaryAtomicRuleId"
        ></p-dropdown>
      </div>

      <div class="col-4" *ngIf="updateCompoundRuleDto.secondaryAtomicRuleId != null">
        <label>Operator</label>
      </div>

      <div class="col-8 px-2" *ngIf="updateCompoundRuleDto.secondaryAtomicRuleId != null">
        <p-dropdown
          [options]="compoundOperatorOptions"
          [(ngModel)]="updateCompoundRuleDto.operator"
        ></p-dropdown>
      </div>
    </div>
    <div class="grid mb-2">
      <div class="col-4">
        <label>Grade</label>
      </div>

      <div class="col-8 px-2">
        <p-listbox
          [options]="gradingOptions"
          [(ngModel)]="updateCompoundRuleDto.deployPriorityGradingId"
          [listStyle]="{ 'max-height': '250px', width: '100%' }"
        >
          <ng-template let-grade pTemplate="item">
            <ng-template
              *ngTemplateOutlet="gradingDisplay; context: { $implicit: gradings.get(grade.value) }"
            >
            </ng-template>
          </ng-template>
        </p-listbox>
      </div>

      <div class="col-4">
        <label>Display Order</label>
      </div>

      <div class="col-8 px-2">
        <input pInputText type="number" step="1" [(ngModel)]="updateCompoundRuleDto.displayOrder" />
      </div>
    </div>
  </div>
  <p-footer>
    <button
      (click)="saveCompoundRule()"
      pButton
      [label]="saving ? 'Wait..' : 'Save'"
      [disabled]="saving"
    ></button>
    <button
      pButton
      *ngIf="!isNewCompoundRule"
      (click)="deleteCompoundRule()"
      [label]="saving ? 'Wait..' : 'Delete'"
      [disabled]="selectedCompoundRule?.isElseClause"
      [title]="selectedCompoundRule?.isElseClause ? 'Else clause cannot be deleted' : ''"
    ></button>
  </p-footer>
</p-dialog>

<ng-template #gradingDisplay let-grading>
  <div *ngIf="grading">
    <span [ngStyle]="{ color: grading.colour }" [class]="grading.iconClass"></span>
    {{ grading.description }}
  </div>
</ng-template>
